// extracted by mini-css-extract-plugin
export default {"btn_group":"ButtonGroup_btn_group__pZMC7","btn_rounded":"ButtonGroup_btn_rounded__Nun-L","btn_normal":"ButtonGroup_btn_normal__8a2Q4"};